export class AdminBannerCrudController {
  constructor($scope, BannerService, RegionService, CityService, toastr) {
    $scope.vm = this;
    $scope.bannerFormModel = {
      title: '',
      body: '',
      slot: '',
      location: '',
      filter: {
        region: null,
        city: null,
        minage: 0,
        maxage: 100,
        gender: '',
        vip: false
      }
    };

    $scope.allBannersSelected = {state: false};
    $scope.bannersSelected = {};

    $scope.locations = [
      {place: '/all', 'title': 'All Pages'},
      {place: '/homerd', 'title': 'Home'}
    ];

    $scope.errors = [];

    $scope.filter = {
      selectAge: '0'
    };

    $scope.show = {
      read: true,
      create: false,
      update: false,
      loadImage: false
    };

    $scope.ages = [
      {id: '0', value: "Without age filter"},
      {id: '1', value: "From 18 to 24"},
      {id: '2', value: "From 25 to 31"},
      {id: '3', value: "From 32 to 38"},
      {id: '4', value: "From 39 to 45"},
      {id: '5', value: "From 46 to 52"},
      {id: '6', value: "From 53 to 100"}
    ];

    $scope.allBanners = [];
    $scope.regions = [];
    $scope.cities = [];
    $scope.allCities = [];

    this.BannerService = BannerService;
    this.RegionService = RegionService;
    this.CityService = CityService;
    this.scope = $scope;
    this.scope.toastr = toastr;
    this.init();
}


  init() {
    this.scope.selectAllBanners = (check) => {
      _.forEach(this.scope.allBanners, (banner, key) => {
        this.scope.bannersSelected[banner._id] = !!check;
      })
    }

    this.scope.bannerDelete = () => {
      _.forEach(this.scope.allBanners, (banner, key) => {
        if(this.scope.bannersSelected[banner._id]) {
          this.BannerService.removeBanner(banner._id)
            .then((response) => { let data = response.data;
              this.getBanners();
            })
            .catch((response) => { let e = response.data;
              console.log(e);
            });
        }
      })
    }

    this.getBanners = () => {
      this.BannerService.getBanners()
        .then((response) => { let data = response.data;
          this.scope.allBanners = data.data;
          this.scope.allBannersSelected.state = false;
        })
        .catch((response) => { let err = response.data;
          console.log(err);
        })
    }

      this.RegionService.getRegionsList()
        .then((response) => { let regions = response.data;
          this.scope.regions = regions.data;
        })
        .catch((response) => { let error = response.data;
          console.log("Can`t get regions from database");
        });

      this.CityService.getCitiesList()
        .then((response) => { let cities = response.data;
          this.scope.allCities = cities.data
        })
        .catch((response) => { let error = response.data;
          console.log("Can`t get cities from database");
        });

    this.scope.changeRegion = () => {
      this.scope.cities = [];
      this.scope.bannerFormModel.city = null;
      var region = this.scope.bannerFormModel.filter.region;


      _(this.scope.allCities).forEach((city) => {
        if(city.region == region) {
          this.scope.cities.push(city);
        }
      }).value();
    }

    this.scope.getFilterAge = () => {
      switch (this.scope.filter.selectAge) {
        case '1':
          this.scope.bannerFormModel.filter.minage = 18;
          this.scope.bannerFormModel.filter.maxage = 24;
          break;
        case '2':
          this.scope.bannerFormModel.filter.minage = 25;
          this.scope.bannerFormModel.filter.maxage = 31;
          break;
        case '3':
          this.scope.bannerFormModel.filter.minage = 32;
          this.scope.bannerFormModel.filter.maxage = 38;
          break;
        case '4':
          this.scope.bannerFormModel.filter.minage = 39;
          this.scope.bannerFormModel.filter.maxage = 45;
          break;
        case '5':
          this.scope.bannerFormModel.filter.minage = 46;
          this.scope.bannerFormModel.filter.maxage = 52;
          break;
        case '6':
          this.scope.bannerFormModel.filter.minage = 53;
          this.scope.bannerFormModel.filter.maxage = 100;
          break;
        default:
          this.scope.bannerFormModel.filter.minage = 18;
          this.scope.bannerFormModel.filter.maxage = 100;
          break;
      }
    }

    this.scope.setFilterAge = () => {
      var selectAge = {
        minage: this.scope.bannerFormModel.filter.minage,
        maxage: this.scope.bannerFormModel.filter.maxage
      };

      if (selectAge.minage == 18 && selectAge.maxage == 24) {
        this.scope.filter.selectAge = '1';
      } else if (selectAge.minage == 25 && selectAge.maxage == 31) {
        this.scope.filter.selectAge = '2';
      } else if (selectAge.minage == 32 && selectAge.maxage == 38) {
        this.scope.filter.selectAge = '3';
      } else if (selectAge.minage == 39 && selectAge.maxage == 45) {
        this.scope.filter.selectAge = '4';
      } else if (selectAge.minage == 46 && selectAge.maxage == 52) {
        this.scope.filter.selectAge = '5';
      } else if (selectAge.minage == 53 && selectAge.maxage == 100) {
        this.scope.filter.selectAge = '6';
      } else {
        this.scope.filter.selectAge = '0';
      }
    }

    this.scope.changeCrudView = (view) => {
      this.scope.show.create = false;
      this.scope.show.read = false;
      this.scope.show.update = false;
      this.scope.show.loadImage = false;

      this.scope.show[view] = true;

      if(this.scope.show.loadImage) {
        this.scope.bannerFormModel = {
          title: '',
          body: '',
          image: '',
          slot: '',
          location: '',
          type: 2,
          filter: {
            region: null,
            city: null,
            minage: 0,
            maxage: 100,
            gender: '',
            vip: false
          }
        };
      }

      else if(this.scope.show.create) {
        this.scope.bannerFormModel = {
          title: '',
          body: '',
          slot: '',
          location: '',
          type: 1,
          filter: {
            region: null,
            city: null,
            minage: 0,
            maxage: 100,
            gender: '',
            vip: false
          }
        };
      }
    }

    this.scope.changeCrudView('read');
    this.getBanners();

    this.scope.createBanner = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      })

      if(this.scope.errors.length) {
        return false;
      }

      this.scope.getFilterAge();

      if(!this.scope.bannerFormModel.filter.region || this.scope.bannerFormModel.filter.region == '0') {
        this.scope.bannerFormModel.filter.region = null;
      }

      if(!this.scope.bannerFormModel.filter.city || this.scope.bannerFormModel.filter.city == '0') {
        this.scope.bannerFormModel.filter.city = null;
      }



      this.BannerService.createBanner(this.scope.bannerFormModel)
      .then((response) => { let data = response.data;
        this.scope.changeCrudView('read');
        this.getBanners();
      }).catch((response) => { let e = response.data;
        console.log(e);
      })
    }

    this.scope.loadFileImage = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      })

      if(this.scope.errors.length) {
        return false;
      }

      if (!this.scope.bannerFormModel.image.$error) {
        var reader = new window.FileReader();
        reader.readAsDataURL(this.scope.bannerFormModel.image);

        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            if(image.width < 480 || image.height < 50) {
                this.scope.toastr.warning('Tu foto debe ser por lo menos de 450x50');
                return;
            }

            this.scope.bannerFormModel.image.src = reader.result;
            this.scope.uploadBanner();
          }

          image.src = reader.result;
        };

      } else {
        this.scope.toastr.warning("error image");
        return;
      }
    }

    this.scope.uploadBanner = () => {
      if(!this.scope.saving) {
        this.scope.saving = true;

        this.BannerService.createBannerImage(this.scope.bannerFormModel)
          .then((response) => { let data = response.data;
              this.scope.saving = false;
              this.scope.changeCrudView('read');
              this.getBanners();
          })
          .catch((response) => { let data = response.data;
            this.scope.saving = false;
            this.scope.toastr.error('error banner upload');
            console.log(data);
        });
      }
    }

    this.scope.updateUploadBanner = () => {
      if(!this.scope.saving) {
        this.scope.saving = true;

        this.BannerService.updateBannerImage(this.scope.bannerFormModel)
          .then((response) => { let data = response.data;
              this.scope.saving = false;
              this.scope.changeCrudView('read');
              this.getBanners();
          })
          .catch((response) => { let data = response.data;
            this.scope.saving = false;
            this.scope.toastr.error('error banner upload');
            console.log(data);
        });
      }
    }

    this.scope.updateBanner = (banner) => {
      this.scope.bannerFormModel = angular.copy(banner);
      this.scope.bannerFormModel.filter.gender = this.scope.bannerFormModel.filter.gender ? this.scope.bannerFormModel.filter.gender + '' : null;
      this.scope.setFilterAge();

      this.scope.changeCrudView('update');
    }

    this.scope.updateBannerBtn = (form) => {
      this.scope.errors = [];
      _.forEach(form, (obj, key) => {
        if(key[0] == "$") {
          return;
        }

        _.forEach(obj.$error, (err, keyErr) => {
          if(keyErr == 'required') {
            this.scope.errors.push('The ' + key + ' is required!')
          }
        })
      })

      if(this.scope.errors.length) {
        return false;
      }


      ///////////////////////////////////////
      if(!this.scope.bannerFormModel.filter.region) {
        this.scope.bannerFormModel.filter.region = null;
      }

      if(!this.scope.bannerFormModel.filter.city) {
        this.scope.bannerFormModel.filter.city = null;
      }

      this.scope.getFilterAge();
      ///////////////////////////////////////

      if(!this.scope.bannerFormModel.image) {
        this.BannerService.updateBanner(this.scope.bannerFormModel)
        .then((response) => { let data = response.data;
          this.scope.changeCrudView('read');
          this.getBanners();
        }).catch((response) => { let e = response.data;
            console.log(e);
        })
      }
      else if(this.scope.bannerFormModel.type == 1) {
        this.BannerService.updateBanner(this.scope.bannerFormModel)
        .then((response) => { let data = response.data;
          this.scope.changeCrudView('read');
          this.getBanners();
        }).catch((response) => { let e = response.data;
            console.log(e);
        })
      } else if(this.scope.bannerFormModel.type == 2) {
        if (!this.scope.bannerFormModel.image.$error) {
          var reader = new window.FileReader();
          reader.readAsDataURL(this.scope.bannerFormModel.image);
          reader.onloadend = () => {
            this.scope.bannerFormModel.image.src = reader.result;
            this.scope.updateUploadBanner();
          };
        } else {
          this.scope.toastr.warning("error image");
          return;
        }
      }
    }

    this.scope.removeBanner = (id) => {
      this.BannerService.removeBanner(id)
      .then((response) => { let data = response.data;
      }).catch((response) => { let e = response.data;
        console.log(e);
      })
      this.getBanners();
    }
  }
}
